<fieldset
	[ngClass]="{ horizontal: layout === 'horizontal' }"
	cdxFieldset
	legend="{{ label }}"
	[i18n]="'@@form-title'"
	[formGroup]="group"
	[hideLegend]="hideLegend"
	layout="large"
>
	<form-input [formControlName]="getLabel(i)" *ngFor="let option of options; let i = index" inputType="checkbox">
		<label [for]="getLabel(i)" label>{{ option.text }}</label>
	</form-input>
</fieldset>
